import React from "react";
import { Routes, Route } from "react-router-dom";
import Main from "../components/Main/Main";
import About from "../components/Company/About";
import Project from "../components/Research/Project";
import News from "../components/News/News";
import Contact from "../components/Contact/Contact";
import Publications from "../components/Research/Publications";
import Patents from "../components/Research/Patents";
import NewsDetail from "./../components/News/NewsDetail";
import ProjectDetail from "../components/Research/ProjectDetail";
import PublicationsDetail from "../components/Research/PublicationsDetail";
import PatentsDetail from "../components/Research/PatentsDetail";
import Vision from "../components/Company/Vision";
import Ceo from "../components/Company/Ceo";
import CoreTech from "./../components/Company/CoreTech";

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<Main />} />
      <Route path="/about" element={<About />} />
      <Route path="/ceo" element={<Ceo />} />
      <Route path="/vision" element={<Vision />} />
      <Route path="/coretech" element={<CoreTech />} />
      <Route path="/project" element={<Project />} />
      <Route path="/publications" element={<Publications />} />
      <Route path="/patents" element={<Patents />} />
      <Route path="/news" element={<News />} />
      {/* pvKey를 동적 경로 매개변수로 설정 */}
      <Route path="/contact" element={<Contact />} />
      <Route path="/project/detail/:idx" element={<ProjectDetail />} />
      <Route
        path="/publications/detail/:idx"
        element={<PublicationsDetail />}
      />
      <Route path="/patents/detail/:idx" element={<PatentsDetail />} />{" "}
      <Route path="/news/detail/:idx" element={<NewsDetail />} />{" "}
    </Routes>
  );
};

export default Router;
